class AppointmentSelect {
    constructor(element) {
        this.form = element
        this.selectWrapperSelector = '.js-appointment-select'
        this.selectSelector = '.js-select'
        this.initListeners()
    }

    initListeners() {
        this.initChangeListener()
        this.initResponseListener()
    }

    initResponseListener() {
        $(this.form).on('turboForm:response', this.turboFormHandler.bind(this))
    }

    initChangeListener() {
        $(this.form).on('option:changed', this.selectSelector, this.sendForm.bind(this))
    }

    turboFormHandler(e) {
        const response = JSON.parse(e.detail.response);
        const data = response[0].data

        for (const key in data) {
            const selectButton = $('.js-appointment-select-button-' + key)
            selectButton[0]._SelectButton.destroy()
            this.replaceSelectButton(selectButton, data[key])

            const newSelectButton = $('.js-appointment-select-button-' + key)
            const newSelect = newSelectButton.find(this.selectSelector)
            new SelectButton(newSelectButton[0])
            new BaseSelect(newSelect[0])
        }
    }

    replaceSelectButton(selectButton, data) {
        selectButton.replaceWith(data)
    }

    sendForm() {
        this.submitButton.click();
    }

    get submitButton() {
        return $(this.form).find('button[type="submit"]')
    }
}

$('.js-appointment-choice-all').each((i, item) => new AppointmentSelect(item))
